import { render, staticRenderFns } from "./CoreScripts.vue?vue&type=template&id=4745255a&scoped=true&"
import script from "./CoreScripts.vue?vue&type=script&lang=ts&"
export * from "./CoreScripts.vue?vue&type=script&lang=ts&"
import style0 from "./CoreScripts.vue?vue&type=style&index=0&id=4745255a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745255a",
  null
  
)

export default component.exports